import gql from 'graphql-tag';

export default gql`
  query paypalSettings {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          paypalBannersEnabled
        }
      }
    }
    settings {
      paypal {
        enabled
        clientToken
        reauthorizationPercentage
        travelInsuranceEnabled
      }
    }
  }
`;
